import { capitalize } from '@repo-level/core-front';
import { forwardRef, TextareaHTMLAttributes } from 'react';

import { FieldStructureProps } from '../structures/FieldStructure';
import { InputStructure } from '../structures/InputStructure';

import { ScInputProps, ScTextArea } from './styled';

export type TextAreaProps = TextareaHTMLAttributes<HTMLTextAreaElement> &
  FieldStructureProps & {
    icon?: string;
  } & Omit<ScInputProps, 'error' | 'icon'>;

export const TextAreaBlock = forwardRef<HTMLTextAreaElement, TextAreaProps>(
  ({ error, hideErrorMessage, prefix, disabled, icon, ...rest }, ref) => (
    <InputStructure
      error={error}
      hideErrorMessage={hideErrorMessage}
      disabled={disabled}
      height={132}
      {...rest}
    >
      <ScTextArea
        {...rest}
        icon={icon != null}
        error={error != null}
        ref={ref}
        disabled={disabled}
        className={rest.value != null && rest.value !== '' ? 'filled' : ''}
        placeholder={rest.placeholder && capitalize(rest.placeholder)}
      />
    </InputStructure>
  )
);
